import React, { useState } from "react";
import { Container } from "@mui/system";
import { Box, Typography } from "@mui/material";
// import shop from '../Images/Shop.png';
// import line from '../Images/line_2.png'
// import user from '../Images/user_2.png';
import OutlinedInput from "@mui/material/OutlinedInput";
import Button from '@mui/material/Button'
// import closeBtn from './images/close btn.png'
import MerchantRegStepper from "./MerchantRegStepper";
import CustomizedSteppers from "../Subscription_Type/Stepper";

function MerchantRegistration() {
  const [heightProp, setheightProp] = useState("800px");

    return (
        <>
            <Container sx={{ 
                backgroundColor: '#F9FFFF',
                height:'auto',
                display:'flex',
                justifyContent:{lg:"space-between",md:'space-between',sm:'center',xs:'center'},
                backgroundImage: "url(/images/IllustrationsBg.svg)",
                backgroundRepeat: "no-repeat",
                // width: "100%",
                // height: "1021px",
                // height: "100vh",
                backgroundSize: {xl:"cover",lg:"cover",md:"cover",sm:"cover",xs:'none'},
                backgroundPosition: "center",
                }} maxWidth >
                <Box className="btnBox">
                    <Button sx={{marginTop:3}}>
                        {/* <img src={closeBtn} /> */}
                    </Button>
                </Box>
                <Box className="merchantBox" sx={{marginTop:5}}>
                    <Box sx={{ padding: '24px', boxSizing: 'border-box', width: {lg:'526px',md:'526px',sm:'526px',xs:'100%'},mb:'50px', height: `${heightProp}`, backgroundColor: '#ffff', border: '1px solid #E1E1E6', borderRadius: '4px' }}>
                        
                        <Typography sx={{ fontSize: { lg: 32, md: 32, sm: 20, xs: 20 }, lineHeight: '125%', fontWeight: '600', fontFamily: 'Outfit' }}>Become Caterer Partner</Typography>
                        <Typography sx={{ fontFmaily: 'Outfit', fontStyle: 'normal', fontWeight: '400', fontSize: '16px', lineHeight: '160%', color: '#545359' }}>Lorem Ipsum is simply dummy text of the printing and typesetting industry</Typography>
                        <Box sx={{ display: "flex", justifyContent: 'center', alignItems: 'center', }}>
                            {/* <img src={shop} />
                            <img src={line} />
                            <img src={user} /> */}

                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
                        <MerchantRegStepper setheightPropFunc={setheightProp}/>
                        {/* <CustomizedSteppers/> */}
                            {/* <Typography sx={{ fontFamily: 'Outfit', fontWeight: '400', lineHeight: '160%', fontSize: '16px', color: '#2B817B', marginTop: 1 }}>Merchant Registration</Typography>
                            <Typography sx={{ fontFamily: 'Outfit', fontWeight: '400', lineHeight: '160%', fontSize: '16px', color: '#9EA3AE', marginTop: 1 }}>Owner Information</Typography> */}
                        </Box>
                        {/* <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '500', fontSize: '20px', lineHeight: '140%', color: '#1A1824', letterSpacing: '0.015em', marginTop: 1 }}>Merchant Name</Typography>
                        <OutlinedInput placeholder="Enter your merchant name" sx={{ boxSizing: 'border-box', padding: '15px', width: '478px', height: '56px', border: '1px solid #E1E1E6', borderRadius: '4px', marginTop: 1 }} />
                        <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '500', fontSize: '20px', lineHeight: '140%', color: '#1A1824', letterSpacing: '0.015em', marginTop: 1 }}>Address</Typography>
                        <OutlinedInput placeholder="Enter your address" sx={{ boxSizing: 'border-box', padding: '15px', width: '478px', height: '56px', border: '1px solid #E1E1E6', borderRadius: '4px', marginTop: 1 }} />
                        <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '500', fontSize: '20px', lineHeight: '140%', color: '#1A1824', letterSpacing: '0.015em', marginTop: 1 }}>Certification</Typography>
                        <OutlinedInput placeholder="Upload your certification" sx={{ boxSizing: 'border-box', padding: '15px', width: '478px', height: '56px', border: '1px solid #E1E1E6', borderRadius: '4px', marginTop: 1 }} />
                        <Typography sx={{ fontFamily: 'Outfit', fontWeight: '400', fontSize: '16px', lineHeight: '160%', letterSpacing: '0.015em', color: '#545359', marginTop: 1 }}>By procceeding. I Agree to Uber’s Terms of Use and acknowledge that i have read the Privacy Policy</Typography>
                        <Button sx={{ padding: '11px 20px', width: '447px', height: '48px', backgroundColor: '#2B817B', borderRadius: '6px', color: 'white', marginTop: 2 }}>Continue</Button> */}



                    </Box>

                </Box>
            </Container>

        </>
    )
}

export default MerchantRegistration